export default "__VITE_PUBLIC_ASSET__725d61ad__"